import React from "react";
import PropTypes from "prop-types";

import Switch from "../../components/Switch/Switch.jsx";
import ListItem from "../../components/ListItem/ListItem.jsx";

const ServiceBusiness = ({ isSelected, service, selectService }) => {
  const handleClickHeader = event => {
    event.preventDefault();
    selectService(service.id);
  };

  return (
    <ListItem isRounded {...service} color="#2A2E35" bg="#F4F4F4" handleClick={handleClickHeader}>
      <Switch onChange={() => null} checked={isSelected} />
    </ListItem>
  );
};

ServiceBusiness.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  service: PropTypes.object.isRequired,
  selectService: PropTypes.func.isRequired,
};

export default ServiceBusiness;
